import React, { useEffect, useState } from "react";
import styles from "../style.module.scss";
import { useSelector } from "react-redux";
import PricingDetails from "./PricingDetails";

const PricingSection = () => {
  const [opened, setOpened] = useState(false);

  const pricingDetails = useSelector(
    (state) => state?.overviewReducer?.graphCourseData?.coupons?.[0]
  );
  const state = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );

  const graphCourseData = useSelector(
    (state) => state?.overviewReducer?.graphCourseData
  );

  let appliedCoupon = graphCourseData?.appliedCoupon;

  useEffect(() => {
    if (appliedCoupon?.code) {
      setOpened(true);
    }
  }, [appliedCoupon?.code]);

  // console.log("pricingDetails", pricingDetails);
  return (
    <>
      <div
        className={
          opened
            ? `${styles["accordion-item"]} ${styles["accordion-item--opened"]}`
            : styles["accordion-item"]
        }
        {...{
          onClick: () => {
            setOpened(!opened);
          },
        }}
      >
        <>
          <div {...{ className: styles["accordion-item__line"] }}>
            <span {...{ className: styles["accordion-item__title"] }}>
              {pricingDetails?.priceDetailNew?.label}
            </span>
            <div className={styles.Pricing__Heading__Pricing}>
              <span className={styles.Pricing__Heading__Pricing__ActualPrice}>
                {pricingDetails?.priceDetailNew?.decoratedText}
              </span>
              <span className={styles.Pricing__Heading__Pricing__DiscountPrice}>
                {pricingDetails?.priceDetailNew?.finalPrice}
              </span>
              <span {...{ className: styles["accordion-item__icon"] }} />
            </div>
          </div>
          <div {...{ className: styles["accordion-item__inner"] }}>
            <div {...{ className: styles["accordion-item__content"] }}>
              {state?.metaData?.isPurchased ? null : (
                <PricingDetails pricingDetails={pricingDetails} />
              )}
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default PricingSection;
